import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Structure from './components/Structure';
import Philosophy from './components/Philosophy';
import Perspective from './components/Perspective';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="min-h-screen bg-background flex flex-col overflow-x-hidden">
      <Header />
      <main className="flex-grow">
        <Hero />
        <Structure />
        <Philosophy />
        <Perspective />
        <About />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;